import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var SuperscriptSvg = function SuperscriptSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.874.5c-.76 0-1.376.616-1.376 1.375v.627h1v-.627c0-.207.168-.375.376-.375h2.25c.208 0 .376.168.376.375v.97a.38.38 0 0 1-.225.344l-2.953 1.292c-.5.219-.824.713-.824 1.26v1.762H22v-1h-4.502V5.74c0-.15.088-.284.225-.344l2.953-1.292c.5-.219.824-.713.824-1.26v-.97c0-.76-.616-1.375-1.375-1.375zM3.38 23.325 9 16.768l5.62 6.557.76-.65L9.659 16l5.72-6.675-.758-.65L9 15.232 3.38 8.675l-.76.65L8.343 16 2.62 22.675z"
  }));
};
export var Superscript = function Superscript(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: SuperscriptSvg
  }));
};